import { UUID } from 'node:crypto';

// Configuration
export interface IConfiguration {
	id: UUID;
	alias: string;
	description: string;
	infoColumns: IInfoColumn[];
	statusColumns: IStatusColumn[];
	orderPositionSql?: string;
}

export interface IInfoColumn {
	title: string;
	source: string;
	type: DataTypes;
	format: string;
}

export interface IStatusColumn {
	title: string;
	terminalIds: UUID[];
	planLinksIds: UUID[];
}

export enum DataTypes {
	String = 'String',
	Number = 'Number',
	Time = 'Time',
	Date = 'Date',
}

// OrderPosition
export interface IOrderPosition {
	id?: string;
	batchId: string;
	orderNumber: number;
	position: number;
	data: Record<string, unknown>;
}

export interface ITerminalStatus {
	batchId: string;
	orderNumber: number;
	position: number;
	terminalId: string;
	status: TerminalStatusState; // Computed by backend
	itemOperations: IItemOperation[];
}

export interface ITerminalStatusCellStateChanged {
	status: ITerminalStatus;
	previousStatus?: TerminalStatusState;
	currentStatus: TerminalStatusState;
}

export interface ITerminalStatusRowStateChanged {
	orderNumber: number;
	position: number;
	terminalStatuses: ITerminalStatus[];
	previousStatus: TerminalStatusState;
	currentStatus: TerminalStatusState;
}

export interface IItemOperation {
	id?: string;
	alias?: string;
	items: IItem[];
}

export interface IItem {
	completed: boolean;
	ready: boolean;
	reordered: boolean;
}

export interface INodeColor {
	background: string;
	accent: string;
}

export enum TerminalStatusState {
	Irrelevant = 'irrelevant',
	Pending = 'pending',
	Ready = 'ready',
	InProgress = 'inprogress',
	Completed = 'completed',
}
